import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\GetImportController::__invoke
* @see app/Http/Controllers/Import/GetImportController.php
* @route '/api/import/{import}'
*/
const GetImportController = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetImportController.url(args, options),
    method: 'get',
})

GetImportController.definition = {
    methods: ["get","head"],
    url: '/api/import/{import}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Import\GetImportController::__invoke
* @see app/Http/Controllers/Import/GetImportController.php
* @route '/api/import/{import}'
*/
GetImportController.url = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { import: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { import: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            import: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: typeof args.import === 'object'
        ? args.import.id
        : args.import,
    }

    return GetImportController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\GetImportController::__invoke
* @see app/Http/Controllers/Import/GetImportController.php
* @route '/api/import/{import}'
*/
GetImportController.get = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetImportController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Import\GetImportController::__invoke
* @see app/Http/Controllers/Import/GetImportController.php
* @route '/api/import/{import}'
*/
GetImportController.head = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetImportController.url(args, options),
    method: 'head',
})

export default GetImportController